import { IGameRow } from '@models/Game';

export const map = new Map([
  ['%Date&TimeOfWin%', 'winTime'],
  ['%ValueBaseCurrency%', 'winInBase'],
  ['%ValuePlayerCurrency%', 'winInPlayer'],
  ['%ProgressiveName%', 'progressiveName'],
  ['%JPLevelName%', 'jackpotLevelName'],
  ['%OperatorName%', 'operatorName'],
  ['%LicenseeName%', 'licenseeName'],
  ['%GameName%', 'gameName'],
  ['%Username%', 'username'],
  ['%PlayerID%', 'playerId'],
  ['%VIPLevel%', 'vipLevel'],
  ['%Country%', 'country'],
  ['%IP%', 'ip'],
]);

export const DEFAULT_PREVIEW_VALUES: Partial<Preview> = {
  from: 'jp_alerts@isoftbet.com',
  licenseeName: 'ISoftBet',
  operatorName: 'ISoftBet',
  username: 'jack123',
  playerId: '8270297212',
  vipLevel: '-',
  country: 'UK',
  ip: '164.88.24.1',
  tierNumber: '0',
  tierPrizeType: 'Jackpot',
  tierDisplayName: 'Display Name',
};

/**
 * Preview model for email alerts preview display
 */
export class Preview {
  from = '';
  to = '';
  winTime = new Date();
  winInPlayer = '';
  winInBase = '';
  progressiveName = '';
  jackpotLevelName = '';
  licenseeName = '';
  operatorName = '';
  gameName = '';
  tierNumber = '';
  tierPrizeType = '';
  tierDisplayName = '';
  skinId = '';
  username = '';
  playerId = '';
  vipLevel = '';
  country = '';
  ip = '';
  subject = '';

  /**
   * Parse data from creation form
   * @param formData
   * @param {string} currency
   * @param {string} progressiveName
   * @param {string} levelName
   * @param {IGameRow} game
   */
  constructor(formData: any, currency: string = '', progressiveName: string = '', levelName: string = '', game: IGameRow) {
    this.from = DEFAULT_PREVIEW_VALUES.from;
    this.to = formData.emails.join(', ');
    this.winTime = new Date();
    this.winInBase = `${formData.triggerValue ?? 0} ${currency}`;
    this.winInPlayer = `${formData.triggerValue ?? 0} ${currency}`;
    this.progressiveName = progressiveName;
    this.jackpotLevelName = levelName;
    this.licenseeName = DEFAULT_PREVIEW_VALUES.licenseeName;
    this.operatorName = DEFAULT_PREVIEW_VALUES.operatorName;
    this.username = DEFAULT_PREVIEW_VALUES.username;
    this.gameName = game ? game.name : '';
    this.tierNumber = DEFAULT_PREVIEW_VALUES.tierNumber;
    this.tierPrizeType = DEFAULT_PREVIEW_VALUES.tierPrizeType;
    this.tierDisplayName = DEFAULT_PREVIEW_VALUES.tierDisplayName;
    this.skinId = game ? String(game.skinId) : '';
    this.playerId = DEFAULT_PREVIEW_VALUES.playerId;
    this.country = DEFAULT_PREVIEW_VALUES.country;
    this.vipLevel = DEFAULT_PREVIEW_VALUES.vipLevel;
    this.ip = DEFAULT_PREVIEW_VALUES.ip;
    this.subject = this.parseSubject(formData.subject);
  }

  /**
   * Parse subject from template to display
   * @param {string} value
   * @return {string}
   */
  private parseSubject(value: string): string {
    return value
      .split(' ')
      .map((word) => {
        if (word[0] === '%' && word[word.length - 1] === '%') {
          return this[map.get(word)];
        }

        return word;
      })
      .join(' ');
  }
}
